import {
  getSurface,
  getWorkspaceSection,
  WORKSPACE_SECTIONS,
  type Surface,
  type WorkspaceSection,
} from '@/lib/shell/surface';

export const LAST_SURFACE_KEY = 'mh_last_surface';
export const LAST_WORKSPACE_SECTION_KEY = 'mh_last_workspace_section';

export const DEFAULT_WORKSPACE_SECTION: WorkspaceSection = 'campaigns';

export { WORKSPACE_SECTIONS, type Surface, type WorkspaceSection };

export function getStoredSurface(): Surface | null {
  if (typeof window === 'undefined') return null;
  try {
    const v = window.sessionStorage.getItem(LAST_SURFACE_KEY);
    return v === 'deck' || v === 'workspace' ? v : null;
  } catch {
    return null;
  }
}

export function setStoredSurface(surface: Surface): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(LAST_SURFACE_KEY, surface);
  } catch {
    // sessionStorage can throw in private mode; ignore.
  }
}

export function getStoredWorkspaceSection(): string {
  if (typeof window === 'undefined') return DEFAULT_WORKSPACE_SECTION;
  try {
    return (
      window.sessionStorage.getItem(LAST_WORKSPACE_SECTION_KEY) ??
      DEFAULT_WORKSPACE_SECTION
    );
  } catch {
    return DEFAULT_WORKSPACE_SECTION;
  }
}

export function setStoredWorkspaceSection(section: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(LAST_WORKSPACE_SECTION_KEY, section);
  } catch {
    // ignore
  }
}

export function deriveSurfaceFromPath(pathname: string): Surface {
  return getSurface(pathname);
}

export function deriveWorkspaceSectionFromPath(pathname: string): WorkspaceSection | null {
  return getWorkspaceSection(pathname);
}
